/** studio-shop D4, web-studio-sites D7: what the grid's current state requires a drawing to show (nothing with no product). */
import type { RequiredParts } from '../../contract/required';
import type { ShopGridState } from './contract';

/** Each product's tile opening it, with its name and its price inside. */
export const requiredParts: RequiredParts<ShopGridState> = (state) =>
  state.products.flatMap((p) => [
    { part: 'tile', item: p.handle, action: 'open' },
    ...['title', 'price'].map((part) => ({ part, item: p.handle, in: 'tile' })),
  ]);
